import moment from 'moment';
import { LitEntity, renderIf, html, css } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-property';
import '../../devices/props/device-firmware-mode';
import '../../devices/props/device-sensor-type';

class WorkOrderReviewDevice extends LitEntity {
  static get styles() {
    return [sharedStyles, css`
      :host {
        display: flex;
        flex-wrap: wrap;
      }
      .column {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
      }
      .column bn-property {
        min-width: 50%;
        margin-bottom: .5em;
      }
    `];
  }

  render() {
    if (!this.entity) {
      return;
    }

    return html`
      <div class="column">
        <bn-property stacked label="Serial">${this.entity.properties.deviceId}</bn-property>
        <bn-property stacked label="Hardware Version">${this._orUnknown(this.entity.properties.hardwareVersion)}</bn-property>
        <bn-property stacked label="Firmware Version">${this._orUnknown(this.entity.properties.firmwareVersion)}</bn-property>
        <bn-property stacked label="Sensor Type"><device-sensor-type .href="${this.href}"></device-sensor-type></bn-property>
        <bn-property stacked label="Mode">
          <device-firmware-mode .href="${this.href}"></device-firmware-mode>
        </bn-property>
        <bn-property stacked label="External Antenna">${this._orUnknown(this.entity.properties.hasExternalAntenna)}</bn-property>
        <bn-property stacked label="xbee Version">${this._orUnknown(this.entity.properties.xbeeVersion)}</bn-property>
        <bn-property stacked label="ECN">${this._orUnknown(this.entity.properties.engineeringChangeNotice)}</bn-property>
        <bn-property stacked label="Battery Level">${this._orUnknown(this.entity.properties.batteryVoltage, 'V')}</bn-property>
        <bn-property stacked label="Factory Setup" title=${this.entity.properties.factorySetupAt}>${moment(this.entity.properties.factorySetupAt).format('MMM D, h:mm a')}</bn-property>
      </div>
    `;
  }

  _orUnknown(value, postfix) {
    if (value === undefined) {
      return html`unknown`;
    }

    return html`${value}${renderIf(postfix, html`<span class='unit'>${postfix}</span>`)}`;
  }
}

window.customElements.define('work-order-review-device', WorkOrderReviewDevice);
